import { Api, withCancelToken } from '../api';
import { reporter } from '../utils/error-reporter';
import { BuildAreaCountyResponse, BuildAreaResponse } from './types';
import { buildAreaCountyValidator } from './utils';

const BASE_URL = 'api/web/build-area';

export const BuildAreaApi = (api: Api) => ({
  /**
   * Fetch build area map data
   */
  fetchMapData: withCancelToken((cancelToken) => async () => {
    const resp = await api.get<BuildAreaResponse>(
      BASE_URL,
      { cancelToken },
    );

    return resp;
  }),

  /**
   * Fetch BuildAreaCounty
   */
  fetchCounty: withCancelToken((cancelToken) => async (id: string, options?: { includeState?: boolean; includeRegion?: boolean }) => {
    const includes = [];
    if (options?.includeState) {
      includes.push('state');
    }
    if (options?.includeRegion) {
      includes.push('region');
    }
    const resp = await api.get<BuildAreaCountyResponse>(
      `${BASE_URL}/county/${id}`,
      {
        params: {
          include: includes.length ? includes.join(',') : undefined,
        },
        cancelToken
      },
    );

    const county = await buildAreaCountyValidator.validate(resp.data)
      .catch(reporter.notifyAndThrow)

    return { ...resp, data: county };
  }),
})
